import { createContext, useContext, useEffect, useState } from "react";
import { IAuthContext, IAuthError } from "./types";
import { ACCESS_TOKEN_DATA_KEY } from "src/constants";
import { getAuthUserCodeFromUrl } from "./utils";
import { createToken } from "src/api";
import { useHistory } from "react-router";
import { getAccessToken } from "src/utils";
import { incrementLogin } from "src/api"
import crypto from "crypto";
import pkceChallgenge from "pkce-challenge";

const login = (): void => {
  const challenge  = pkceChallgenge(128)
  const state  = pkceChallgenge(50).code_verifier

  localStorage.setItem("code_verifier", challenge.code_verifier)
  if(!localStorage.getItem("state")){
    localStorage.setItem("state", state)
  }
  const nonce = crypto.randomBytes(16).toString("base64");
  window.location.href = process.env.REACT_APP_ACP_URL! + 
  process.env.REACT_APP_AUTHORIZE_ENDPOINT! + 
  `?client_id=${process.env.REACT_APP_ACP_CLIENT_ID!}` +
  `&response_type=code` +
  `&scope=openid email profile offline_access` +
  `&redirect_uri=${process.env.REACT_APP_REDIRECT_URI!}` +
  `&state=${state}` +
  `&nonce=${nonce}` +
  `&code_challenge_method=S256` +
  `&code_challenge=${challenge.code_challenge}`;};

const AuthContext = createContext<IAuthContext | undefined>({});

const AuthProvider: React.FC = (props) => {
  const [error, setError] = useState<IAuthError | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const userCodeParams = getAuthUserCodeFromUrl();
  const history = useHistory();

  useEffect(() => {
    const accessToken = getAccessToken();
    const isLoggedIn = !!accessToken;
    setIsLoggedIn(isLoggedIn);
  }, []);

  useEffect(() => {
    if (history.location.pathname === "/") {
      if (userCodeParams?.error) {
        setError(userCodeParams?.error);

        localStorage.removeItem(ACCESS_TOKEN_DATA_KEY);
        setIsLoggedIn(false);

        return;
      }

      if (userCodeParams?.userCode && !isLoggedIn) {
        setIsLoading(true);

        createToken(userCodeParams?.userCode).then((response) => {
          if (!response?.error) {
            localStorage.setItem(
              ACCESS_TOKEN_DATA_KEY,
              JSON.stringify({
                accessToken: response?.access_token,
                idToken: response?.id_token,
                tokenType: response?.token_type,
                expiresIn: response?.expires_in,
                refreshToken: response?.refresh_token,
              })
            );
            localStorage.setItem("refreshToken", response?.refresh_token);
            
            setIsLoggedIn(true);
            setIsLoading(false);
            incrementLogin();
          } else {
            setError({
              code: response?.error,
              description: response?.error_description,
            });
            localStorage.removeItem(ACCESS_TOKEN_DATA_KEY);

            setIsLoggedIn(false);
            setIsLoading(false);
          }
        });
        return;
      }
    }
  }, [history?.location?.pathname]);

  return (
    <AuthContext.Provider
      value={{
        error,
        isLoading,
        isLoggedIn,
        login,
      }}
      {...props}
    />
  );
};

const useAuth = (): IAuthContext | undefined =>
  useContext<IAuthContext | undefined>(AuthContext);

export { AuthProvider, useAuth };
